module.exports = __webpack_public_path__ + "img/flick_test.d33125e2.jpg";